export const USE_ZERO_DOWN_EXPERIMENT_V1_CONFIG = "use_zero_down_experiment_v1";
export const ZERO_DOWN_EXPERIMENT = "zero_down_payment_v2";

export const GUEST_FEE_DISCOUNT_EXPERIMENT = "guest_fee_discount_25_50";
export const GUEST_FEE_DISCOUNT_PARAM = "guest_fee";
export const GUEST_FEE_DISCOUNT_BUCKETS = [
  "full",
  "25_percent_off",
  "50_percent_off",
] as const;

export const NEST_PROCESSING_FEE_EXPERIMENT = "nest_processing_fee_test_v2";
export const NEST_PROCESSING_FEE_PARAM = "nest_fees";
